<template>
	<app-card>
		<v-form>
			<h3>DANH SÁCH CÁC PHIẾU CHI TIẾT</h3>
			<p class="fs-14 grey--text">
				Danh sách các phiếu chi tiết của phiếu
				<span class="font-weight-bold green--text">{{
					selected_receipt.receipt_id
				}}</span>
			</p>
			<v-data-table
				:headers="headers"
				:items="receipts"
				:rows-per-page-items="rowPerPage"
				disable-initial-sort
				class="elevation-1"
				:loading="loader"
			>
				<template v-slot:items="props">
					<tr>
						<td class="text-xs-center">{{ props.index + 1 }}</td>
						<td class="text-xs-left">{{ props.item.title }}</td>
						<td class="text-xs-center">
							{{ props.item.receipt_id }}
						</td>
						<td class="text-xs-center">
							{{ props.item.receipt_date | formatTimeServer }}
						</td>
						<td class="text-xs-center">{{ props.item.room_id }}</td>
						<td class="text-xs-right">
							{{ props.item.receipt_amount | formatNumber }}
						</td>
						<td class="text-xs-center">
							{{ props.item.collector }}
						</td>
						<td class="text-xs-center text-no-wrap">
							{{ props.item.note }}
						</td>
					</tr>
				</template>
			</v-data-table>
		</v-form>
	</app-card>
</template>
<script>
import api from "Api";
import { dayDiff } from "Helpers";

export default {
	name: "dialog-phieu-chi-tiet",
	props: {
		selected_receipt: Object
	},
	data() {
		return {
			loader: false,
			rowPerPage: [20, 50, 100, { text: "Tất cả", value: -1 }],
			headers: [
				{ text: "STT", value: "stt" },
				{ text: "Loại phiếu", value: "type", align: "left" },
				{ text: "Mã số phiếu", value: "receipt_id", align: "center" },
				{ text: "Ngày tạo", value: "receipt_date", align: "center" },
				{ text: "Số phòng", value: "room_id", align: "center" },
				{ text: "Số tiền", value: "receipt_amount", align: "right" },
				{ text: "Bảo vệ", value: "collector", align: "center" },
				{ text: "Ghi chú", value: "note", align: "center" }
			],
			receipts: [],
			receipt_text: {
				"ROOM": "Phiếu thu tiền phòng",
				"OTHER": "Phiếu thu khác",
				"DEPOSIT": "Phiếu cọc",
				"DIFFERENCE": "Chênh lệch của phiếu CG "
			}
		};
	},
	watch: {
		selected_receipt() {
			this.getReceiptData();
		}
	},
	methods: {
		async getReceiptData() {
			this.loader = true;
			this.receipts = [];
			const receipt_data = await Promise.all([
				api.getReceiptRoomAndOther(
					"receiptCollectedId=" + this.selected_receipt.receipt_id
				),
				api.getDepositReceipts(
					"receiptCollectedId=" + this.selected_receipt.receipt_id
				),
				api.getReceiptDifference(
					"receiptCollectedId=" + this.selected_receipt.receipt_id
				)
			]);
			this.loader = false;
			receipt_data.forEach(receiptResult => {
				if (receiptResult.status == 200) {
					this.receipts = this.receipts.concat(
						receiptResult.data.map(receipt => {
							receipt.type = receipt.month
								? receipt.room_id ?  "ROOM" : "OTHER"
								: receipt.date_deposit
								? "DEPOSIT"
								: "DIFFERENCE";
							if (receipt.type === "ROOM" || receipt.type === "OTHER") {
								receipt.receipt_date = receipt.date_collected;
								receipt.receipt_amount =
									receipt.collected_amount;
								receipt.title = this.receipt_text[receipt.type];
							} else if (receipt.type === "DEPOSIT") {
								receipt.receipt_date = receipt.date_deposit;
								receipt.receipt_amount = receipt.deposit_amount;
								receipt.title = this.receipt_text[receipt.type];
							} else if (receipt.type === "DIFFERENCE") {
								receipt.receipt_date = receipt.date_collected;
								receipt.receipt_amount =
									receipt.collected_amount;
								receipt.title =
									this.receipt_text[receipt.type] +
									receipt.created_by_receipt_collected_id;
							}
							return receipt;
						})
					);
				}
			});
			// this.receipts.map((rep, index) => {
			// 	rep.stt = index + 1;
			// 	return rep;
			// });
			this.receipts.sort((a, b) =>
				dayDiff(b.receipt_date, a.receipt_date)
			);
			// Get danh sách những phiếu chưa thu tiền (cọc, phòng)
			// Merge + sort theo ngày tạo phiếu
		}
	}
};
</script>

<style>
</style>